import { PacketType } from "../../../enum/PacketType";
import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import { Input } from "../../../lib/Input";
import { Time } from "../../../lib/Time";
import Vector2 from "../../../math/Vector2";
import Gun from "../../Gun";
import HomingRocketBehavior from "../../HomingRocketBehavior";
import Player from "../../Player";

export default class HomingRockets extends Gun {
    constructor(player: Player) {
        super(player, {
            damage: 100,
            fireRate: 1,
            reloadTime: 6,
            bulletSpeed: 100,
            magSize: 6,
            mouseTrigger: 2
        });
    }

    // Reload(): void {
        
    // }

    onShoot(): void {
        const centerSpawnPos = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 4));
        const vel = this.player.velocity.add(this.player.transform.forward.scale(this.bulletSpeed));

        const [, rocket] = this.player.engine.NewGameObjectWithScript<HomingRocketBehavior>(HomingRocketBehavior);
        rocket.team = this.player.team;
        rocket.ownerName = this.player.name;
        rocket.damage = this.damage;
        rocket.transform.position = centerSpawnPos;
        rocket.velocity = vel.clone();
        rocket.transform.rotation = this.player.transform.rotation.clone();

        this.player.engine.sendCreatePacket(rocket.gameObject, {
            type: "ROCKET",
            values: [
                {
                    key: "team",
                    value: this.player.team || "",
                    type: PacketValueSerialType.String
                },
                {
                    key: "velocity",
                    value: rocket.velocity,
                    type: PacketValueSerialType.Vector2
                },
                {
                    key: "ownerName",
                    value: this.player.name,
                    type: PacketValueSerialType.String
                },
                {
                    key: "damage",
                    value: this.damage,
                    type: PacketValueSerialType.UInt
                },
            ]
        })
    }

    Shoot() {
        
        if (this.bullets === 0 || this.fireTimer > 0) return;
        
        this.bullets--;
        this.onShoot();
        this.fireTimer = 1/this.fireRate;
        if (this.reloadTimer === 0) this.reloadTimer = this.reloadTime;
        
    }

    Update(): void {
        if (!this.player.isOwner || this.player.isDead) return;

        if (this.fireTimer > 0) {
            this.fireTimer -= Time.deltaTime;

            if (this.fireTimer <= 0) this.fireTimer = 0;
        }

        if (this.mouseTrigger != undefined && Input.GetMouseButton(this.mouseTrigger)) {
            
            this.Shoot();
        }

        if (this.bullets < this.magSize && this.reloadTimer > 0) {
            this.reloadTimer -= Time.deltaTime;

            if (this.reloadTimer <= 0) {
                this.bullets++;

                if (this.bullets < this.magSize) {
                    this.reloadTimer = this.reloadTime;
                } else this.reloadTimer = 0;
            }
        }
    }

    Draw(yOffset: number): void {
        const ctx = this.player.ctx;
        const engine = this.player.engine;

        for (let i = 0; i < this.magSize; i++) {
            ctx.fillStyle = this.bullets > i ? '#ffffff' : '#ffffff55';
            engine.FillRect(this.player.transform.position.add(new Vector2(25 - 4 - 6*i, this.player.size + yOffset)), new Vector2(2, 4));
        }
    }
}